import React from 'react'
import { Collapse, Descriptions, Typography } from 'antd'
import { IDeliveryCostSharing } from 'models/orders'
import { getNormalizedPrice } from 'shared/utils/getNormalizedPrice'
import styles from './OrderEdit.module.scss'

interface IDeliveryCostSharingDetailsProps {
  costSharing: IDeliveryCostSharing
}

const formatDistance = (distance: number) =>
  `${distance.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} км`

export const DeliveryCostSharingDetails: React.FC<
  IDeliveryCostSharingDetailsProps
> = ({ costSharing }) => (
  <Collapse className={styles.costSharing}>
    <Collapse.Panel header='Расчёт субсидии доставки' key='cost-sharing'>
      <Descriptions
        bordered
        size='small'
        column={{ xs: 1, sm: 2, lg: 3 }}
        className={styles.costSharingDescriptions}
      >
        <Descriptions.Item label='Стоимость перевозчика'>
          {getNormalizedPrice(costSharing.actual_cost)}
        </Descriptions.Item>
        <Descriptions.Item label='Доля покупателя'>
          {getNormalizedPrice(costSharing.buyer_share)}
        </Descriptions.Item>
        <Descriptions.Item label='Доля продавца'>
          {getNormalizedPrice(costSharing.seller_share)}
        </Descriptions.Item>
        <Descriptions.Item label='Доля платформы'>
          {getNormalizedPrice(costSharing.platform_share)}
        </Descriptions.Item>
        <Descriptions.Item label='Причина'>
          {costSharing.reason}
        </Descriptions.Item>
        {costSharing.zone && (
          <Descriptions.Item label='Зона'>
            {costSharing.zone}
          </Descriptions.Item>
        )}
        {costSharing.distance_km != null && (
          <Descriptions.Item label='Расстояние'>
            {formatDistance(costSharing.distance_km)}
          </Descriptions.Item>
        )}
        {costSharing.distance_source && (
          <Descriptions.Item label='Источник расстояния'>
            {costSharing.distance_source}
          </Descriptions.Item>
        )}
        <Descriptions.Item label='Перевозчик'>
          {costSharing.carrier}
        </Descriptions.Item>
        <Descriptions.Item label='Минимальная цена килограмма'>
          {getNormalizedPrice(costSharing.minimum_item_price_per_kg)}
        </Descriptions.Item>
        <Descriptions.Item label='Ключ правила'>
          {costSharing.rule_key ? (
            <Typography.Text code copyable>
              {costSharing.rule_key}
            </Typography.Text>
          ) : (
            '—'
          )}
        </Descriptions.Item>
        <Descriptions.Item label='Версия политики'>
          {costSharing.policy_version}
        </Descriptions.Item>
      </Descriptions>
    </Collapse.Panel>
  </Collapse>
)
